<template>
  <div class="rg-video-playback-button-wrapper">
    <button
      :disabled="disabled"
      @click="handleClick"
      class="menu-icon-button rg-video-playback-button"
    >
      <span class="menu-icon"></span>
      <span>{{ buttonText }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "RgVideoPlayBackButton",
  props: {
    handleClick: {
      type: Function,
      default: () => {},
    },
    buttonText: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_mixin.scss";
@import "@/assets/scss/aisea/_variables.scss";

.rg-video-playback-button-wrapper {
  button {
    all: unset;
    outline: revert;
  }

  display: inline-flex;

  gap: 10px;
  height: 35px;
  user-select: none;

  .menu-icon-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 20px;
    align-items: center;
    cursor: pointer;
    border-radius: 30px;
    background: $aisea-gray-black;

    &:hover {
      background: $aisea-gray;
    }

    &:active {
      background: $aisea-mouse-gray;
    }

    &:disabled {
      background: $aisea-gray-black;
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .menu-icon {
    width: 15px;
    height: 15px;
    background: url("~@/assets/images/icons/lolcal/recorded_camera_button.svg")
      no-repeat;
    background-size: contain;
  }
}
</style>
